// ==========================================
//  VendorModel.js
// ==========================================
export class VendorModel {
  static ALLOWED_KEYS = Object.freeze([
    "id",
    "vendorId",
    "vendorName",
    "contactPerson",
    "email",
    "phone",
    "address",
    "state",
    "country",
    "pincode",
    "gstin",
    "description",
    "status",
    "companyId",
    "company",
    "metadata",
  ]);

  static ALLOWED_METADATA_KEYS = Object.freeze([
    "createdAt",
    "createdBy",
    "updatedAt",
    "updatedBy",
    "deletedFlag",
  ]);

  static ID_FIELD = "vendorId";
  static NAME_FIELD = "vendorName";
  static GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  constructor(data = {}, { isCreation = false } = {}) {
    for (const key of VendorModel.ALLOWED_KEYS) {
      if (key === "metadata") {
        this.metadata = {
          createdAt: null,
          createdBy: null,
          updatedAt: null,
          updatedBy: null,
          deletedFlag: false,
        };
      } else if (key === "status") {
        this.status = "active";
      } else if (key === "country") {
        this.country = "IN";
      } else {
        this[key] = null;
      }
    }

    if (isCreation) {
      this.id = data.id || crypto.randomUUID();
      this.vendorId = data.vendorId || null;
      this.vendorName = data.vendorName || null;
      this.contactPerson = data.contactPerson || null;
      this.email = data.email || null;
      this.phone = data.phone || null;
      this.address = data.address || null;
      this.state = data.state || null;
      this.country = data.country || "IN";
      this.pincode = data.pincode || null;
      this.gstin = data.gstin || null;
      this.description = data.description || null;
      this.status = data.status || "active";
      this.companyId = data.companyId || null;
      this.company = data.company || null;

      const now = new Date().toISOString();
      this.metadata = {
        createdAt: data.metadata?.createdAt || data.createdAt || now,
        createdBy: data.metadata?.createdBy || data.createdBy || "system",
        updatedAt: data.metadata?.updatedAt || data.updatedAt || now,
        updatedBy: data.metadata?.updatedBy || data.updatedBy || "system",
        deletedFlag: data.metadata?.deletedFlag ?? false,
      };
    } else {
      for (const key of Object.keys(data)) {
        if (!VendorModel.ALLOWED_KEYS.includes(key)) continue;

        if (key === "metadata") {
          this.metadata = { ...this.metadata, ...(data.metadata || {}) };
        } else {
          this[key] = data[key];
        }
      }
      if (data.createdAt) this.metadata.createdAt = data.createdAt;
      if (data.createdBy) this.metadata.createdBy = data.createdBy;
      if (data.updatedAt) this.metadata.updatedAt = data.updatedAt;
      if (data.updatedBy) this.metadata.updatedBy = data.updatedBy;
    }
  }

  isValid() {
    if (!this.vendorName || !String(this.vendorName).trim()) return false;
    if (!this.vendorId || !String(this.vendorId).trim()) return false;
    if (this.gstin && !VendorModel.GSTIN_REGEX.test(this.gstin)) return false;
    return true;
  }

  toPayload() {
    const payload = {};
    for (const key of VendorModel.ALLOWED_KEYS) {
      if (key === "metadata") {
        payload.metadata = {};
        for (const mk of VendorModel.ALLOWED_METADATA_KEYS) {
          payload.metadata[mk] = this.metadata?.[mk] ?? (mk === "deletedFlag" ? false : null);
        }
      } else if (this[key] !== undefined) {
        payload[key] = this[key];
      }
    }
    return payload;
  }

  toJSON() {
    return this.toPayload();
  }
}